import { ComponentProps } from "react";
import {
  ExtractRouteParams,
  Redirect,
  Route,
  RouteComponentProps,
} from "react-router";

import { SUPPORTED_ROUTES } from "@/utils/constants/routing";

export type PathToComponentProps<Path extends SUPPORTED_ROUTES> =
  React.ComponentType<
    RouteComponentProps<{ [key in keyof ExtractRouteParams<Path>]: string }>
  >;

function TypeSafeRoute<Path extends SUPPORTED_ROUTES>(
  props: Omit<ComponentProps<typeof Route>, "path" | "component" | "render"> & {
    path: Path;
  } & { component: PathToComponentProps<Path> },
) {
  return (
    <Route
      {...props}
      component={props.component as ComponentProps<typeof Route>["component"]}
    />
  );
}

function TypeSafeRedirect(
  props: Omit<ComponentProps<typeof Redirect>, "to" | "path"> & {
    path: SUPPORTED_ROUTES;
    to: SUPPORTED_ROUTES;
  },
) {
  return <Redirect {...props} />;
}

export { TypeSafeRedirect, TypeSafeRoute };
